import { render, staticRenderFns } from "./ViewTestuser.vue?vue&type=template&id=a2d684a4&"
import script from "./ViewTestuser.vue?vue&type=script&lang=js&"
export * from "./ViewTestuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports